import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {EXPORT_TEST_ACTION} from '../../models/export-form.model';
import {ActionButtonComponent, ActionLabel} from '../action-button/action-button.component';

@Component({
    selector: 'app-export-test-button',
    standalone: true,
    imports: [ActionButtonComponent],
    template: `
        @if (testAction; as test) {
            <app-action-button
                variant="outline-primary"
                [label]="label()"
                [icon]="icon()"
                [busy]="test.running()"
                [disabled]="test.disabled()"
                (run)="test.run()" />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportTestButtonComponent {
    protected readonly testAction = inject(EXPORT_TEST_ACTION, {optional: true});

    private readonly isIdle = computed(() => {
        const test = this.testAction;
        return test !== null && !test.running() && test.cooldownSeconds() === 0;
    });

    protected readonly label = computed<ActionLabel>(() => {
        const test = this.testAction;
        if (test === null || this.isIdle()) {
            return {key: 'savedexport_test_run', module: 'export'};
        }
        if (test.running()) {
            return {key: 'savedexport_test_running', module: 'export'};
        }
        return {
            key: 'savedexport_test_cooldown',
            module: 'export',
            params: [test.cooldownSeconds().toString()],
        };
    });

    protected readonly icon = computed(() => (this.isIdle() ? 'bi-send' : null));
}
